// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Payment Settings — compact form layout */

.ps-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 100px);
  min-height: 480px;
  max-height: calc(100vh - 88px);
}

.ps-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.ps-toolbar-note {
  flex: 1 1;
  font-size: 15px;
  color: #94a3b8;
}

.ps-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.ps-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.ps-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.ps-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ps-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.ps-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.ps-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.ps-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.ps-toast--ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.ps-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.ps-main {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 12px;
  overflow: hidden;
}

.ps-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ps-panel-head {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ps-panel-body {
  padding: 12px 14px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.ps-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 8px;
  background: #fafbfc;
}

.ps-toggle:last-child {
  margin-bottom: 0;
}

.ps-toggle--on {
  background: #ecfdf5;
  border-color: #bbf7d0;
}

.ps-toggle--warn {
  background: #fef2f2;
  border-color: #fecaca;
}

.ps-toggle-text strong {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.ps-toggle-text span {
  font-size: 13px;
  color: #94a3b8;
}

.ps-switch {
  position: relative;
  width: 40px;
  height: 22px;
  border: none;
  border-radius: 999px;
  background: #cbd5e1;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;
}

.ps-switch--on {
  background: #22c55e;
}

.ps-switch--warn {
  background: #ef4444;
}

.ps-switch-handle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
}

.ps-switch--on .ps-switch-handle,
.ps-switch--warn .ps-switch-handle {
  transform: translateX(18px);
}

.ps-field {
  margin-bottom: 14px;
}

.ps-field:last-child {
  margin-bottom: 0;
}

.ps-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.ps-field textarea,
.ps-field input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  box-sizing: border-box;
  resize: vertical;
}

.ps-field textarea {
  min-height: 72px;
}

.ps-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.ps-tag {
  font-size: 13px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
}

.ps-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
}

.ps-spin {
  animation: ps-spin 0.8s linear infinite;
}

@keyframes ps-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 900px) {
  .ps-main {
    grid-template-columns: 1fr;
    overflow: visible;
  }

  .ps-page {
    height: auto;
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/website/PaymentSettingsManager.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["/* Payment Settings — compact form layout */\n\n.ps-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 100px);\n  min-height: 480px;\n  max-height: calc(100vh - 88px);\n}\n\n.ps-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.ps-toolbar-note {\n  flex: 1;\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.ps-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.ps-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ps-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.ps-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ps-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.ps-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.ps-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.ps-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.ps-toast--ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.ps-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.ps-main {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.ps-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ps-panel-head {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ps-panel-body {\n  padding: 12px 14px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.ps-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  background: #fafbfc;\n}\n\n.ps-toggle:last-child {\n  margin-bottom: 0;\n}\n\n.ps-toggle--on {\n  background: #ecfdf5;\n  border-color: #bbf7d0;\n}\n\n.ps-toggle--warn {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.ps-toggle-text strong {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.ps-toggle-text span {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.ps-switch {\n  position: relative;\n  width: 40px;\n  height: 22px;\n  border: none;\n  border-radius: 999px;\n  background: #cbd5e1;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.2s;\n}\n\n.ps-switch--on {\n  background: #22c55e;\n}\n\n.ps-switch--warn {\n  background: #ef4444;\n}\n\n.ps-switch-handle {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s;\n}\n\n.ps-switch--on .ps-switch-handle,\n.ps-switch--warn .ps-switch-handle {\n  transform: translateX(18px);\n}\n\n.ps-field {\n  margin-bottom: 14px;\n}\n\n.ps-field:last-child {\n  margin-bottom: 0;\n}\n\n.ps-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 6px;\n}\n\n.ps-field textarea,\n.ps-field input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-family: inherit;\n  box-sizing: border-box;\n  resize: vertical;\n}\n\n.ps-field textarea {\n  min-height: 72px;\n}\n\n.ps-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.ps-tag {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.ps-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.ps-spin {\n  animation: ps-spin 0.8s linear infinite;\n}\n\n@keyframes ps-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 900px) {\n  .ps-main {\n    grid-template-columns: 1fr;\n    overflow: visible;\n  }\n\n  .ps-page {\n    height: auto;\n    max-height: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
